/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Clear_Day_FilterInputs */

const en_orders_clear_day_filter = /** @type {(inputs: Orders_Clear_Day_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Day Filter`)
};

const es_orders_clear_day_filter = /** @type {(inputs: Orders_Clear_Day_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpiar filtro de dia`)
};

/**
* | output |
* | --- |
* | "Clear Day Filter" |
*
* @param {Orders_Clear_Day_FilterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_clear_day_filter = /** @type {((inputs?: Orders_Clear_Day_FilterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Clear_Day_FilterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_clear_day_filter(inputs)
	return es_orders_clear_day_filter(inputs)
});